module.exports = "/images/Dashboard.svg?979e06e1d1a3f83802098405c5c70b6e";